import { Component, OnInit } from "@angular/core";
import { catchError, tap } from "rxjs/operators";
import { SassCertificateModel } from "src/app/shared/models/sassCertificate.model";
import { AppSpinnerModule } from "src/app/shared/modules/app-spinner.module";
import { CertificateService } from "src/app/shared/services/certificate.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddAccountCertificateComponent } from "../add-account-certificate/add-account-certificate.component";
import { ActivatedRoute } from "@angular/router";
import { AppDialogModule } from "../../shared/components/app-dialog/app-dialog.component";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-account-certificate",
    templateUrl: "./account-certificate.component.html",
    styleUrls: ["./account-certificate.component.scss"],
    standalone: false
})
export class AccountCertificateComponent implements OnInit {
  certificates: SassCertificateModel[] = [];
  isReadDataFromSassEnabled: boolean = false;

  constructor(
    private readonly certificateService: CertificateService,
    private readonly spinner: AppSpinnerModule,
    private readonly modalService: NgbModal,
    private readonly route: ActivatedRoute,
    private readonly dialog: AppDialogModule,
    private readonly toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.isReadDataFromSassEnabled = this.route.snapshot.data.isReadDataFromSassEnabled;
    this.getCertificatesForCurrentUser();
  }

  getCertificatesForCurrentUser(): void {
    this.spinner.show();
    this.certificateService.getCurrentAccountCertificates()
      .pipe(
        tap((response) => {
          this.spinner.hide();
          this.certificates = response.certificates;
        }),
        catchError(() => {
          this.spinner.hide();
          return [];
        }
        )).subscribe();
  }

  deleteConfirmationDialog(certificateGuid: string) {
    this.dialog.show({
      title: "Delete Certificate",
      message: "Are you sure you want to delete this certificate?",
      noButtonText: "Cancel",
      yesButtonText: "Delete Certificate",
    }).result.then((dialogResult) => {
      if (dialogResult === "yes") {
        this.deleteCertificate(certificateGuid);
      }
    });
  }

  deleteCertificate(certificateGuid: string) {
      this.spinner.show();
      this.certificateService.deleteCertificate(certificateGuid).subscribe(
        () => {
          this.spinner.hide();
          this.toastr.success("Certificate deleted successfully");
          this.getCertificatesForCurrentUser();
        },
        (err) => {
          this.spinner.hide();
          this.toastr.error(err.error.error);
        }
      );
    }
  
  openCertificateModal() {
    const modalRef = this.modalService.open(AddAccountCertificateComponent, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.mode = this.certificates.length != 0 ? 'edit' : 'add';
    modalRef.componentInstance.isReadDataFromSassEnabled = this.isReadDataFromSassEnabled;
    modalRef.componentInstance.currentCertificateGuid = this.certificates.length != 0 ? this.certificates[0].certificateGuid : '';

    modalRef.result.then(() => {
      this.getCertificatesForCurrentUser();
    });
  }
}
